import { useTranslation } from 'react-i18next';
import { cn, localizedDateFormatter } from '@anytag/shared-utils';
import { AppLanguage, PostDetailsType } from '@anytag/shared-types';

export interface DateProps {
  className?: string;
  value?: PostDetailsType['postDate'];
}

export const Date = ({ value, className }: DateProps) => {
  const { i18n } = useTranslation();

  return value ? (
    <div className={cn('w-max flex-none text-sm whitespace-nowrap text-black-60', className)}>
      {localizedDateFormatter(value, 'PPP', i18n.language as AppLanguage)}
    </div>
  ) : null;
};
